import type { Money } from "@openmoney/proto/google/type/money";

interface MoneyAmountProps {
  value: Money | undefined;
  className?: string;
  asCells?: boolean;
}

export function MoneyAmount({ value, className, asCells = false }: MoneyAmountProps) {
  if (!value) {
    if (asCells) {
      return (
        <>
          <td className={className}>—</td>
          <td className={className} />
        </>
      );
    }
    return <span className={className}>—</span>;
  }

  const { currencyCode, units, nanos } = value;
  console.log(value);
  if (!currencyCode) {
    return null;
  }

  // Convert units (BigInt) and nanos (int32) to decimal
  const unitsNum = Number(units ?? 0n);
  const nanosNum = Number(nanos ?? 0);
  const amount = unitsNum + nanosNum / 1_000_000_000;

  // Format with Intl.NumberFormat and separate currency symbol from amount
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode,
    compactDisplay: "long",
    currencySign: "accounting",
  });

  const parts = formatter.formatToParts(amount);
  const currencySymbol = parts.find((p) => p.type === "currency")?.value || "";
  const numberParts = parts
    .filter((p) => p.type !== "currency" && p.type !== "literal")
    .map((p) => p.value)
    .join("");

  if (asCells) {
    return (
      <>
        <td className={`${className} text-left`}>{currencySymbol}</td>
        <td className={`${className} text-right`}>{numberParts}</td>
      </>
    );
  }

  return (
    <span className={`${className} flex items-center`}>
      <span>{currencySymbol}</span>
      <span className="grow" />
      <span>{numberParts}</span>
    </span>
  );
}
